import { render, staticRenderFns } from "./MediaView.vue?vue&type=template&id=5032fe2e&scoped=true"
import script from "./MediaView.vue?vue&type=script&lang=js"
export * from "./MediaView.vue?vue&type=script&lang=js"
import style0 from "./MediaView.vue?vue&type=style&index=0&id=5032fe2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5032fe2e",
  null
  
)

export default component.exports